
  import { computed, defineComponent } from 'vue';
  import CallInfo from '@/components/calls/CallInfo.vue';
  import DropdownList from '@/components/common/DropdownList.vue';
  import { $currentActiveCallId, activeCalls, transferCall } from '@/store/calls';
  import { useStore } from 'effector-vue/composition';

  export default defineComponent({
    name: 'TransferCallList',
    components: {
      DropdownList,
      CallInfo,
    },
    setup() {
      const activeCallsState = useStore(activeCalls);
      const currentCall = useStore($currentActiveCallId);

      const candidatesForTransfer = computed(() =>
        activeCallsState.value.filter((call) => call.id !== currentCall.value)
      );

      return {
        transferCall,
        candidatesForTransfer,
      };
    },
  });
